import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { BodyS } from 'atoms/typography';
import { useFiatBalance } from 'hooks/wallets/useFiatBalance';
import { payment } from 'lib/glossary';
import type { Color } from 'style/types';

import { FiatWalletIcon } from '../Icon/FiatWalletIcon';
import { SorareWallet } from '../SorareWallet';

type Props = {
  withoutBalance?: boolean;
  column?: boolean;
  balanceColor?: Color;
  label?: MessageDescriptor;
};

export const FiatWallet = ({
  withoutBalance,
  column,
  balanceColor = 'var(--c-white)',
  label = payment.sorareCashWallet,
}: Props) => {
  const { availableBalanceWithCurrencySymbol } = useFiatBalance();
  return (
    <SorareWallet
      icon={<FiatWalletIcon />}
      label={<FormattedMessage {...label} />}
      balance={
        <BodyS color={balanceColor}>{availableBalanceWithCurrencySymbol}</BodyS>
      }
      withoutBalance={withoutBalance}
      column={column}
    />
  );
};
